/* eslint-disable @typescript-eslint/no-unused-vars */
import { inject, Injectable } from '@angular/core';
import { AppContextService } from 'src/app/shared/services/app-context/app-context.service';
import { environment } from 'src/environments/environment';
import { Logger } from '../../interfaces/Logger';
import Rollbar from 'rollbar';
import { LoggerConsoleService } from './logger-console.service';
import { ENVIRONMENT_NAME } from 'src/environments/environment-name.enum';

@Injectable({
  providedIn: 'root',
})
export class LoggerRollbarService implements Logger {
  private rollbar: Rollbar;
  private readonly appContextService = inject(AppContextService);
  private readonly loggerConsoleService =
    environment.name === ENVIRONMENT_NAME.alpha 
      ? inject(LoggerConsoleService)
      : null;
  private readonly isEnabled = environment.rollbar.enabled;

  constructor() {
    this.rollbar = new Rollbar({
      accessToken: environment.rollbar.token,
      environment: environment.name,
      captureUncaught: true,
      captureUnhandledRejections: true,
      enabled: this.isEnabled,
    });
  }

  error(error: Error, customData?: Rollbar.LogArgument): void {
    if (environment.name === ENVIRONMENT_NAME.alpha) {
      this.loggerConsoleService?.error(error, customData);
    }

    if (!customData) {
      this.rollbar.error(error);

      return;
    }

    error.message = `${error.message} [Organization: ${this.appContextService.organizationName}] [Service: ${this.appContextService.serviceId}] [Device: ${this.appContextService.deviceName}] `;

    this.rollbar.error(error, customData);
  }

  info(message: string, customData?: Rollbar.LogArgument): void {
    if (environment.name === ENVIRONMENT_NAME.alpha) {
      this.loggerConsoleService?.info(message);
    }

    if (!customData) {
      this.rollbar.info(message);

      return;
    }

    this.rollbar.info(message, customData);
  }

  warning(message: string, customData?: Rollbar.LogArgument): void {
    if (environment.name === ENVIRONMENT_NAME.alpha) {
      this.loggerConsoleService?.warning(message);
    }

    if (!customData) {
      this.rollbar.warning(message);

      return;
    }

    this.rollbar.warning(message, customData);
  }

  debug(message: string, customData?: Rollbar.LogArgument): void {
    if (
      environment.name === ENVIRONMENT_NAME.alpha ||
      environment.name === ENVIRONMENT_NAME.prod
    ) {
      this.loggerConsoleService?.debug(message, customData);
    }

    // We dont' want to take debug actions in production
    return;
  }
}
